const p2 = (n: number) => String(n).padStart(2, "0");

export function formatAxisTime(epoch: number, tfSeconds: number): string {
  const d = new Date(epoch * 1000);
  if (tfSeconds >= 86400) return `${d.getMonth() + 1}/${d.getDate()}`;
  if (tfSeconds >= 60) return `${p2(d.getHours())}:${p2(d.getMinutes())}`;
  return `${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}`;
}

// Average candle duration (s) — used to extrapolate time ↔ index beyond the loaded series.
export function candleStep(candles: { time: number }[], tfSeconds: number): number {
  const N = candles.length;
  if (N < 2) return Math.max(1, tfSeconds);
  const k = Math.min(N - 1, 50);
  const span = candles[N - 1].time - candles[N - 1 - k].time;
  return span > 0 ? span / k : Math.max(1, tfSeconds);
}

// Fractional candle index for an epoch time (binary search + linear interpolation, extrapolated at both ends).
export function fracIndexOfTime(candles: { time: number }[], time: number, step: number): number {
  const N = candles.length;
  if (!N) return 0;
  if (time <= candles[0].time) return (time - candles[0].time) / step;
  if (time >= candles[N - 1].time) return N - 1 + (time - candles[N - 1].time) / step;
  let lo = 0, hi = N - 1;
  while (hi - lo > 1) { const mid = (lo + hi) >> 1; if (candles[mid].time <= time) lo = mid; else hi = mid; }
  const span = candles[hi].time - candles[lo].time || step;
  return lo + (time - candles[lo].time) / span;
}

export function timeOfFracIndex(candles: { time: number }[], idx: number, step: number): number {
  const N = candles.length;
  if (!N) return 0;
  if (idx <= 0) return candles[0].time + idx * step;
  if (idx >= N - 1) return candles[N - 1].time + (idx - (N - 1)) * step;
  const i = Math.floor(idx);
  return candles[i].time + (idx - i) * (candles[i + 1].time - candles[i].time);
}

export function formatDuration(seconds: number): string {
  const s = Math.abs(Math.round(seconds));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return `${Math.floor(s / 86400)}d ${Math.floor((s % 86400) / 3600)}h`;
}

export function formatFullTime(epoch: number): string {
  const d = new Date(epoch * 1000);
  return `${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}`;
}
